module.exports = __webpack_public_path__ + "img/image04.c9552232.jpg";